import React, { useEffect, useState } from "react";
import zohoLogo from "../../images/zoho_logo.png";
import expertDefaultImg from "../../images/expert-default.png";
import AvailabilityComment from "../TopConsultants/AvailabilityComment";
import AvailabilityDate from "../TopConsultants/AvailabilityDate";
import SelectButtonForList from "../SimilarProfilesForList/SelectButtonForList";
import EditProfileBasic from "./EditProfileBasic";

export default function DatabaseResultRow({ consultant, proj_id }) {
  const [exSummary, setExSummary] = useState(null);
  const [exExperience, setExExperience] = useState(null);
  const [availabilityComment, setAvailabilityComment] = useState(null);
  const [availablityDate, setAvailablityDate] = useState(null);
  const [availabiltyBorder, setAvailabiltyBorder] = useState("");
  const [showComment, setShowComment] = useState(false);
  const [exObject, setExObject] = useState({
    expertName: "",
    expertLink: "",
    expertEmail: "",
  });

  const updateProfileData = (exObject) => {
    setExObject(exObject);
  };

  useEffect(() => {
    if (consultant) {
      setExSummary(consultant.summary);
      setExExperience(consultant.experience);
      setAvailabilityComment(consultant.available_comment);
      setAvailablityDate(consultant.available_from);
      setExObject({
        expertName: consultant.name,
        expertLink: consultant.link,
        expertEmail: consultant.email,
      });
    }
  }, [consultant]);

  useEffect(() => {
    if (consultant.experience) {
      let exp = consultant.experience;
      if (exp.startsWith("\r\n")) {
        exp = exp.substring(2);
        setExExperience(exp);
      }
    }
  }, [consultant.experience]);

  useEffect(() => {
    if (availablityDate) {
      const today = new Date();
      const availDate = new Date(availablityDate);
      if (
        availablityDate === "Wed, 01 Jan 2020 00:00:00 GMT" ||
        availablityDate === "Fri, 01 Jan 2010 00:00:00 GMT"
      ) {
        setAvailabiltyBorder("");
      } else if (availDate < today) {
        setAvailabiltyBorder("search-con-img-green");
      } else if (availDate > today) {
        setAvailabiltyBorder("search-con-img-red");
      }
    }
  }, [availablityDate]);

  return (
    <div className="search-con-table-row" id="db-table-row">
      <div className="search-con-row-top">
        <ul className="list-unstyled form-inline">
          <li className="search-con-name-section">
            <a
              href={`/app/ExpertDetails/${consultant.id}`}
              className="search-con-eph-profile"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                className={`search-con-img ${availabiltyBorder}`}
                alt=""
                src={
                  consultant.profile_picture
                    ? consultant.profile_picture
                    : expertDefaultImg
                }
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = expertDefaultImg;
                }}
              />
            </a>
            <div style={{ display: "inline-grid" }}>
              <a
                href={exObject.expertLink}
                className="search-con-name-tag"
                target="_blank"
                rel="noopener noreferrer"
              >
                {exObject.expertName}
              </a>
              {consultant.parcentage && (
                <p style={{ fontSize: "14px" }}>
                  Score: {consultant.parcentage ? consultant.parcentage : null}
                </p>
              )}
            </div>
          </li>
          <li className="search-con-location-section">
            <span className="search-con-location-tag">
              {consultant.location}
            </span>
          </li>
          <li className="search-con-available-comment">
            {showComment && (
              <AvailabilityComment
                comment={availabilityComment}
                expert_id={consultant.id}
                setAvailabilityComment={setAvailabilityComment}
              />
            )}
          </li>
          <li className="search-con-summary">
            <div title="Summary" className="info-div1-scroll">
              {exSummary}
            </div>
          </li>
          <li className="search-con-experience">
            <div title="Experience" className="info-div2-scroll">
              {exExperience}
            </div>
          </li>
          <SelectButtonForList list_id={proj_id} exp_id={consultant.id} />
        </ul>
      </div>
      <div className="search-con-row-bottom">
        <ul className="list-unstyled form-inline" style={{ marginBottom: 0 }}>
          <li className="search-con-email-section">
            <div className="search-con-email">
              <i className="fa-regular fa-envelope" />
              <span>{exObject.expertEmail}</span>
              <EditProfileBasic
                expert_id={consultant?.id}
                expert_Name={consultant?.name}
                expert_link={consultant?.link}
                expert_email={consultant?.email}
                updateProfileData={updateProfileData}
              />
            </div>
          </li>
          <li className="search-con-available-date">
            <i className="calender-icon fa-regular fa-calendar-days" />
            <label>Availability</label>
            <i
              className={
                availabilityComment
                  ? "comment-icon fa-regular fa-comment-dots"
                  : "comment-icon comment-empty fa-regular fa-comment-dots"
              }
              title="Click to see comment"
              onClick={() => setShowComment(!showComment)}
            />
            <AvailabilityDate
              date={consultant.available_from}
              expertID={consultant.id}
              setAvailablityDate={setAvailablityDate}
            />
          </li>
          <li className="search-con-empty-class"></li>
          <li className="search-con-exLogo-section">
            {consultant.logo1 ? <img src={consultant.logo1} alt="" /> : null}
            {consultant.logo2 ? <img src={consultant.logo2} alt="" /> : null}
            {consultant.logo3 ? <img src={consultant.logo3} alt="" /> : null}
            {consultant.logo4 ? <img src={consultant.logo4} alt="" /> : null}
            {consultant.logo5 ? <img src={consultant.logo5} alt="" /> : null}
          </li>
        </ul>
        {consultant.in_zoho === "yes" && (
          <div className="search-con-inZoho">
            <img src={zohoLogo} alt="in_zoho" title="In Zoho" />
          </div>
        )}
      </div>
    </div>
  );
}
